import { ReactNode } from "react";
import { SudoTooltip } from "src/sudokit/components/SudoTooltip/index.tsx";
import { Container } from "./styles";

interface HelpProps {
  children?: ReactNode;
  aria?: string;
}

const Help = ({ children, aria = 'More Information' }: HelpProps) => {
  return (
    <SudoTooltip
      customContent={children}
      triggerClassName="inline-block !background-transparent border-none p-0 m-0 ml-2"
    >
      <Container
        type="button"
        aria-label={aria}
      >
        ?
      </Container>
    </SudoTooltip>
  );
};

export default Help;
